const BASE_PATH = '/api/v1/inventory';

export const UNIFIED_SLOTS_ENDPOINT = `${BASE_PATH}/slots`;
export const CHECK_INVENTORY_EXIST_ENDPOINT = `${BASE_PATH}/slots/gpNGP`;

// Slot type values matching backend SlotType.java constants exactly
export const SLOT_TYPES = {
  GATEWAY: 'gateway',
  STAR_PACKAGE: 'star-package',
  MTHANKYOU: 'mthankyou',
  WP_CLASS1: 'wp-class1',
  ILM_CLASS1: 'ilm-class1',
  MCONTEXTUAL_CLASS1_CPM: 'mcontextual-class1-cpm',
  DCONTEXTUAL_CLASS1_CPM: 'dcontextual-class1-cpm',
  PPP_CLASS1: 'ppp-class1',
  WD2_TARGETED_CLASS1: 'wd2-targeted-class1',
  ROS_DSP_UNGUARANTEED: 'ros-dsp-unguaranteed',
} as const;

export type SlotTypeValue = (typeof SLOT_TYPES)[keyof typeof SLOT_TYPES];

export enum EndpointQueryKeys {
  GET_GATEWAY_DATA = 'get-gateway-data',
  GET_STAR_PACKAGE = 'get-star-package',
  GET_MTHANKYOU = 'get-mthankyou',
  GET_WP_CLASS1 = 'get-wp-class1',
  GET_ILM_CLASS1 = 'get-ilm-class1',
  GET_MCONTEXTUAL_CLASS1_CPM = 'get-mcontextual-class1-cpm',
  GET_DCONTEXTUAL_CLASS1_CPM = 'get-dcontextual-class1-cpm',
  GET_PPP_CLASS1 = 'get-ppp-class1',
  GET_WD2_TARGETED_CLASS1 = 'get-wd2-targeted-class1',
  GET_ROS_DSP_UNGUARANTEED = 'get-ros-dsp-unguaranteed',
  CHECK_INVENTORY_EXIST = 'check-inventory-exist',
}
